import React from 'react';
import PipelineClusterCell from './cells/PipelineClusterCell';
import DeployedRevisionCell from './cells/DeployedRevisionCell';
import StagedRevisionCell from './cells/StagedRevisionCell';

const assignedPipelinesTableColumns = [
  {
    id: 'pipelineName',
    name: 'Pipeline and Cluster',
    selector: row => row.pipelineName,
    cell: row => <PipelineClusterCell pipelineName={row.pipelineName} clusterName={row.clusterName} />,
    sortable: true,
  },
  {
    id: 'playbookRevision',
    name: 'Staged Revision',
    // allow "Staged for delete" to sort together
    selector: row => (!row.playbookStagedForDelete ? row.playbookRevision : 0),
    cell: row => (
      <StagedRevisionCell
        stagedRevision={row.playbookRevision}
        deployedRevision={row.deployedRevision}
        stagedForDelete={row.playbookStagedForDelete}
        revisionDisabled={row.playbookRevisionDisabled}
      />
    ),
    width: '12rem',
    sortable: true,
  },
  {
    id: 'deployedRevision',
    name: 'Deployed Revision',
    selector: row => row.deployedRevision,
    cell: row => (
      <DeployedRevisionCell
        stagedRevision={row.playbookRevision}
        deployedRevision={row.deployedRevision}
        disabled={row.disabled}
        revisionDisabled={row.deployedRevisionDisabled}
      />
    ),
    width: '16rem',
    sortable: true,
  },
];

export default assignedPipelinesTableColumns;
